export default __webpack_public_path__ + "static/media/aula.f61b6253.jpg";